import { motion } from 'framer-motion';
import { Award, Users, Calendar, Shield } from 'lucide-react';

const facts = [
  { icon: Calendar, value: '1998', label: 'Gegründet', bg: 'bg-[#0077D4]', text: 'text-white', labelColor: 'text-slate-300' },
  { icon: Users, value: '4', label: 'Fachkräfte', bg: 'bg-white', text: 'text-[#0077D4]', labelColor: 'text-slate-500' },
  { icon: Award, value: 'VELUX', label: 'Zertifizierter Experte', bg: 'bg-white', text: 'text-[#CC2229]', labelColor: 'text-slate-500' },
  { icon: Shield, value: '25+', label: 'Jahre Erfahrung', bg: 'bg-[#0077D4]', text: 'text-white', labelColor: 'text-slate-300' },
];

export const AboutSection = ({ settings }) => {
  return (
    <section id="ueber-uns" className="py-20 md:py-32 bg-white" data-testid="about-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center">
          {/* Facts Grid */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="grid grid-cols-2 gap-4"
          >
            {facts.map((fact, i) => {
              const Icon = fact.icon;
              return (
                <motion.div
                  key={i}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: i * 0.1 }}
                  className={`${fact.bg} p-8 border border-slate-200 flex flex-col`}
                  data-testid={`about-fact-${i}`}
                >
                  <Icon size={24} className={`${fact.text} mb-4 opacity-60`} />
                  <span className={`font-heading text-3xl sm:text-4xl font-black ${fact.text}`}>
                    {fact.value}
                  </span>
                  <span className={`text-sm mt-2 ${fact.labelColor}`}>
                    {fact.label}
                  </span>
                </motion.div>
              );
            })}
          </motion.div>

          {/* Text */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            <span className="section-label text-[#CC2229]">Über uns</span>
            <h2 className="font-heading text-3xl sm:text-4xl font-black text-slate-900 mt-4 tracking-tight uppercase">
              {settings?.about_headline || 'Zuverlässig. Fachgerecht. Termintreu.'}
            </h2>
            <div className="mt-6 space-y-4">
              {(settings?.about_text || '').split('\n').filter(Boolean).map((para, i) => (
                <p key={i} className="text-slate-600 leading-relaxed">
                  {para}
                </p>
              ))}
            </div>
            <div className="mt-8 pt-8 border-t border-slate-200">
              <p className="text-sm text-slate-500">
                <span className="font-semibold text-slate-700">Inhaber:</span> Andreas Ertel
              </p>
              <p className="text-sm text-slate-500 mt-1">
                <span className="font-semibold text-slate-700">Standort:</span> {settings?.address || 'Teichplatz 7, 01259 Dresden'}
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
